export const numberOfStandardWaste = {amountOfWaste: Math.floor(Math.random() * (15 - 14 + 1) + 14)};